var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-layout",on:{"click":_vm.onchange}},[_c('div',{staticClass:"check-box-outer"},[(_vm.value)?_c('img',{staticStyle:{"width":"12px","height":"12px"},attrs:{"src":_vm.src}}):_vm._e()]),_c('label',{staticClass:"ml-2 lbl_default",style:(_vm.fontStyle)},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }